<template>
  <div>Tab B Content</div>
</template>

<script>
export default {
  name: "TabB",
};
</script>

<style scoped>
</style>